import { render } from "./CreateInstrument.vue?vue&type=template&id=6bf40a34&scoped=true"
import script from "./CreateInstrument.vue?vue&type=script&lang=js"
export * from "./CreateInstrument.vue?vue&type=script&lang=js"

import "./CreateInstrument.vue?vue&type=style&index=0&id=6bf40a34&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf40a34"]])

export default __exports__